import { useContext } from 'react'
import {
  CommentComposer,
  CommentList,
  CommentProvider,
} from 'src/components/ItemComment'
import { useCommentsSectionRef } from 'src/components/ItemComment/commentsScroll'
import Text from 'src/components/ui/Text'
import { EmailVerifyBanner } from 'src/features/User/ForceVerifyEmail/EmailVerifyBanner'
import { RefType } from 'src/services/apollo/generated/graphql'
import { useMe } from 'src/services/helpers/user'
import { ModelDetailContext } from '../context'

export function ModelDetailCommentSectionRedesign(props: StyleProps) {
  const { model } = useContext(ModelDetailContext)
  const { me } = useMe()
  const commentsRef = useCommentsSectionRef()

  if (!model) return null

  const beingMyModel = me?.id === model.authorId

  return (
    <section
      ref={commentsRef}
      className={`${props.className ?? ''} scroll-mt-[--app-header-height]`}
      style={props.style}
    >
      <div className="max-msm:px-2">
        <CommentProvider
          topicId={model.id}
          refType={RefType.Model}
          creatorId={model.authorId ?? undefined}
          totalCount={model.commentCount ?? undefined}
          notifyOnNetworkStatusChange
          initLoadSize={3}
          canDeleteMessage={() => beingMyModel}
        >
          <div className="sticky top-[--app-header-height] -mx-2 px-2 pb-3 pt-3 bg-background border-b border-black/10 dark:border-white/10 z-10">
            <h3 className="font-medium text-base flex items-baseline mb-3">
              <Text i18nKey="common:comments" defaults="Comments" />
              {(model.commentCount ?? 0) > 0 && (
                <span className="text-neutral-500 pl-2 text-xs">
                  {model.commentCount}
                </span>
              )}
            </h3>
            <EmailVerifyBanner className="mb-3" />
            <CommentComposer />
          </div>
          <div className="mt-4">
            <CommentList />
          </div>
        </CommentProvider>
      </div>
    </section>
  )
}
